/* Canvas Helper */

import TextPhotoDefaults from "../enums/TextPhotoDefaults";

const textRenderWrapper = ({ words, context, maxWidth, text, lines }) => {
  const breakChar = '/';
  let renderPerWord = true;

  if (words.length === 1) {
    let metrics = context.measureText(words[0]);
    const testWidth = metrics.width;
    
    if (testWidth > maxWidth) {
      renderPerWord = false;

      let terms = text.split(breakChar);
      let line = '', i, test;

      for (i = 0; i < terms.length; i++) {
        test = terms[i];
        metrics = context.measureText(test);

        while (metrics.width > maxWidth) {
          // Determine how much of the word will fit
          test = test.substring(0, test.length - 1);
          metrics = context.measureText(test);
        }
        if (words[i] !== test) {
          words.splice(i + 1, 0,  words[i].substr(test.length))
          words[i] = test;
        }  
  
        test = line + words[i] + breakChar;  
        metrics = context.measureText(test);
          
        if (metrics.width > maxWidth && i > 0) {
          lines.push(line);
          line = words[i];
        } else {
          line = test;
        }
      }

      lines.push(line);
    }
  }

  return renderPerWord;
}

const CanvasHelper = {

  getBase64ImageFromURL: (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/jpeg', 0.8);
        resolve(dataURL);
      }
      img.onerror = () => {
        reject(false);
      }
      img.src = url;
    })
  },

  addBackgroundColor: ({ canvas, color }) => {
    if (canvas && color) {
      const context = canvas.getContext('2d');

      context.fillStyle = color;
      context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    }
  },

  addImage: async ({ canvas, imageDataURI }) => {
    if (canvas && imageDataURI) {
      const context = canvas.getContext('2d');
  
      const image = new Image();
      image.setAttribute('crossorigin', 'anonymous');
      if (imageDataURI) {
        image.src = imageDataURI;
      }
  
      await image.decode();
  
      const imageWidth = image.width;
      const imageHeight = image.height;
  
      const canvasWidth = canvas.width;
      // const canvasHeight = canvas.height;
  
      const dWidth = canvasWidth;
      const dHeight = imageHeight * (canvasWidth / imageWidth);
      
      context.drawImage(image, 0, 0, dWidth, dHeight);
    }
  },

  addText: ({
    canvas, 
    text, 
    color, 
    x, 
    y, 
    font = TextPhotoDefaults.CANVAS_DEFAULT_FONT, 
    fontSize = TextPhotoDefaults.CANVAS_DEFAULT_FONT_SIZE,
    textAlign = TextPhotoDefaults.CANVAS_DEFAULT_TEXT_ALIGN,
    lineHeight = TextPhotoDefaults.CANVAS_DEFAULT_LINE_HEIGHT
  }) => {
    if (canvas && text && color && x && y) {
      // Parsing values
      x = parseInt(x);
      y = parseInt(y);

      const context = canvas.getContext('2d');
  
      context.font = `${fontSize}px ${font}`;
      context.fillStyle = color;
      context.textAlign = textAlign;

      const maxWidth = canvas.width - (2 * TextPhotoDefaults.CANVAS_PHOTO_PADDING);

      // Wrapping the TEXT
      const words = text.split(' ');
      let line = '';
      let lines = [];

      const renderPerWord = textRenderWrapper({ words, context, maxWidth, text, lines});

      let renderedHeight = 0;
      let renderedWidth = 0;

      if (renderPerWord) {
        for (let n = 0; n < words.length; n++) {
          let testLine = line + words[n] + ' ';
          const metrics = context.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
  
            context.fillText(line, x, y);
            renderedHeight += lineHeight;
            
            line = words[n] + ' ';
            y += lineHeight;
          } else {
            line = testLine;
          }
          renderedWidth = (testWidth > renderedWidth) ? testWidth : renderedWidth;
        }
  
        context.fillText(line, x, y);
        renderedHeight += lineHeight;
      } else {
        for (let i = 0; i < lines.length; i++) {
          context.fillText(lines[i], x, y);
          renderedHeight += lineHeight;
          y += lineHeight;
        }
      }

      return { w: renderedWidth, h: renderedHeight };
    }
  },

  addTextWrap: ({
    canvas, 
    text, 
    color,
    font = TextPhotoDefaults.CANVAS_DEFAULT_FONT, 
    fontSize = TextPhotoDefaults.CANVAS_DEFAULT_FONT_SIZE,
    textAlign = TextPhotoDefaults.CANVAS_DEFAULT_TEXT_ALIGN
  }) => {
    if (canvas && text && color) {
      const specialChar = `b-r`;
      let wrappedText = '';

      const context = canvas.getContext('2d');
  
      context.font = `${fontSize}px ${font}`;
      context.fillStyle = color;
      context.textAlign = textAlign;

      const maxWidth = canvas.width - (2 * TextPhotoDefaults.CANVAS_PHOTO_PADDING);

      // Wrapping the TEXT
      const words = text.split(' ');
      let line = '';
      let lines = [];

      const renderPerWord = textRenderWrapper({ words, context, maxWidth, text, lines});

      let renderedWidth = 0;

      if (renderPerWord) {
        for (let n = 0; n < words.length; n++) {
          let testLine = line + words[n] + ' ';
          const metrics = context.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
            wrappedText += `${line}${specialChar}`;
            line = words[n] + ' ';
          } else {
            line = testLine;
          }
          renderedWidth = (testWidth > renderedWidth) ? testWidth : renderedWidth;
        }
  
        wrappedText += `${line}`;
      } else {
        for (let i = 0; i < lines.length; i++) {
          wrappedText += `${lines[i]}${specialChar}`;
        }
        wrappedText = wrappedText.slice(0, -3);
      }

      wrappedText = encodeURIComponent(wrappedText);
      wrappedText = wrappedText.replaceAll(specialChar, `\n`);
      return wrappedText;
    }
  },

  clear: ({ canvas }) => {
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
  },

}

export default CanvasHelper;
